export const routePaths = {
  init: '/',
  chat: (chatId: string) => `/chats/${chatId}`,
  quote: (quoteId: string) => `/quote/${quoteId}`,
  purchaseOrder: (quoteId: string) => `/purchase-order/${quoteId}`,
}
